<app-agricola-navbar></app-agricola-navbar>

<div class="sis-app">
  <div class="sis-page report-page">

    <!-- Back -->
    <button class="back-link" type="button" (click)="goBack()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M12 4l-6 6 6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>Atras</span>
    </button>

    <!-- Header -->
    <header class="report-header">
      <h1 class="report-title">Reportes</h1>
      <p class="report-subtitle">
        Solicita el reporte que quieres solicitar y a continuación elige los párametros con los que deseas filtrar el reporte
      </p>
    </header>

    <!-- Card: filter & request -->
    <section class="sis-card report-card">
      <h2 class="report-card-title">Filtrar y seleccionar reporte</h2>

      <!-- Tip -->
      <div class="info-banner report-hint">
        <div class="info-banner-icon">
          <img src="assets/agricola/toast-idea.svg" alt="" aria-hidden="true">
        </div>
        <div class="info-banner-text">
          Selecciona las fechas desde y hasta para solicitar tu reporte.
        </div>
      </div>

      <!-- Filters -->
      <div class="grid report-filters">
        <div class="field">
          <label class="field-label" for="report-from">Desde</label>
          <input id="report-from" class="form-input" type="date" [(ngModel)]="fromDate">
        </div>

        <div class="field">
          <label class="field-label" for="report-to">Hasta</label>
          <input id="report-to" class="form-input" type="date" [(ngModel)]="toDate">
        </div>

        <div class="field products-field" #productsField>
          <label class="field-label" for="report-products">Productos</label>
          <button id="report-products" class="form-input products-trigger" type="button" (click)="toggleProductsDropdown()">
            <span>{{ selectedProductsLabel }}</span>
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path d="M5 8l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>

          <div class="products-dropdown" *ngIf="productsDropdownOpen">
            <label class="products-option" *ngFor="let product of availableProducts">
              <input type="checkbox" [checked]="isProductSelected(product)" (change)="toggleProduct(product)">
              <span>{{ product.product_name }}</span>
            </label>
            <p class="products-empty" *ngIf="!availableProducts.length">No hay productos disponibles.</p>
          </div>
        </div>

        <div class="field">
          <label class="field-label" for="report-agency">Agencia</label>
          <select id="report-agency" class="form-input" [(ngModel)]="selectedAgencyCode">
            <option value="">Todas las agencias</option>
            <option *ngFor="let agency of agencyOptions" [value]="agency.value">{{ agency.label }}</option>
          </select>
        </div>
      </div>

      <p class="report-error" *ngIf="errorMessage">{{ errorMessage }}</p>

      <!-- Actions -->
      <div class="report-actions">
        <button class="cancel-btn" type="button" (click)="generate(1)" [disabled]="loadingReport">
          {{ loadingReport ? 'Generando...' : 'Generar Reporte' }}
        </button>
        <button class="apply-button" type="button" (click)="exportReport()" [disabled]="exporting">
          {{ exporting ? 'Solicitando...' : 'Descargar Reporte' }}
        </button>
      </div>
    </section>

    <!-- On-screen results -->
    <section class="sis-card report-card" *ngIf="hasSearched">
      <div class="results-header">
        <h2 class="report-card-title is-left">Resultados</h2>
        <span class="results-count" *ngIf="total">Mostrando {{ rows.length }} de {{ total }}</span>
      </div>

      <div class="table-scroll">
        <table class="sis-table">
          <thead>
            <tr>
              <th>Número Único</th>
              <th>Solicitud</th>
              <th>Nombre de Cliente</th>
              <th>Precio</th>
              <th>Fecha de Venta</th>
              <th>Agencia</th>
              <th>Asistencia</th>
              <th>Código de Vendedor</th>
              <th>Estado</th>
              <th class="actions-col" *ngIf="showRowActions">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of rows">
              <td>{{ row.Unico }}</td>
              <td>{{ row.Solicitud }}</td>
              <td>{{ row.Nombre_Cliente }}</td>
              <td>{{ row.Precio }}</td>
              <td>{{ row.Fech_Venta }}</td>
              <td>{{ row.Agencia }}</td>
              <td>{{ row.Asistencia }}</td>
              <td>{{ row.Cod_Ven }}</td>
              <td>
                <span class="sis-chip" [class.is-active]="row.Estado === 1" [class.is-cancelled]="row.Estado !== 1">
                  {{ estadoLabel(row.Estado) }}
                </span>
              </td>
              <td class="actions-col" *ngIf="showRowActions">
                <div class="row-menu">
                  <button
                    class="row-menu-trigger"
                    type="button"
                    [attr.aria-expanded]="openMenuPolicy === row.Solicitud"
                    aria-label="Documentos de la póliza"
                    (click)="toggleRowMenu(row)">
                    <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <circle cx="10" cy="4" r="1.6"/><circle cx="10" cy="10" r="1.6"/><circle cx="10" cy="16" r="1.6"/>
                    </svg>
                  </button>

                  <div class="row-menu-dropdown" *ngIf="openMenuPolicy === row.Solicitud">
                    <p class="row-menu-loading" *ngIf="isDocsLoading(row)">Cargando…</p>
                    <ng-container *ngIf="!isDocsLoading(row)">
                      <!-- "Ver firma" removido a propósito (no deshabilitado): el
                           negocio pidió no previsualizar la firma aquí. El flujo
                           (viewSignature + modal CSP-safe) sigue en el componente;
                           descomentar este botón lo reactiva.
                      <button type="button" class="row-menu-item" [disabled]="!hasSignature(row)" (click)="viewSignature(row)">
                        Ver firma
                      </button>
                      -->
                      <!-- <button type="button" class="row-menu-item" [disabled]="!hasSignature(row)" (click)="downloadSignature(row)">
                        Descargar firma
                      </button> -->
                      <button type="button" class="row-menu-item" (click)="viewCertificate(row)">
                        Ver certificado
                      </button>
                      <button type="button" class="row-menu-item" (click)="downloadCertificate(row)">
                        Descargar certificado
                      </button>
                    </ng-container>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="!loadingReport && !rows.length">
              <td [attr.colspan]="showRowActions ? 10 : 9" class="table-empty">No se encontraron registros para los filtros seleccionados.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p class="report-error" *ngIf="actionError">{{ actionError }}</p>

      <!-- Certificate open/download error: status-aware message + manual retry.
           Same guidance as the sale wizard, for the "listo a los segundos" case. -->
      <div class="document-error-box" *ngIf="certificateError">
        <p class="report-error">{{ certificateError }}</p>
        <button
          type="button"
          class="cancel-btn"
          [disabled]="certificateRetrying"
          (click)="retryCertificate()">
          {{ certificateRetrying ? 'Reintentando...' : 'Reintentar' }}
        </button>
      </div>

      <!-- Pager -->
      <div class="pager" *ngIf="total > pageSize">
        <button class="pager-arrow" type="button" (click)="goToPage(page - 1)" [disabled]="page === 1" aria-label="Anterior">‹</button>
        <button
          class="pager-page"
          type="button"
          *ngFor="let n of pageNumbers"
          [class.is-current]="n === page"
          (click)="goToPage(n)">
          {{ n }}
        </button>
        <button class="pager-arrow" type="button" (click)="goToPage(page + 1)" [disabled]="page === totalPages" aria-label="Siguiente">›</button>
      </div>
    </section>

  </div>
</div>

<!-- Feature 2: signature preview modal (data: URL on <img>, CSP-safe) -->
<div class="signature-modal-backdrop" *ngIf="signatureModalOpen" (click)="closeSignatureModal()">
  <div class="signature-modal" (click)="$event.stopPropagation()">
    <div class="signature-modal-header">
      <h3>Firma — {{ signatureModalPolicy }}</h3>
      <button type="button" class="signature-modal-close" aria-label="Cerrar" (click)="closeSignatureModal()">×</button>
    </div>
    <div class="signature-modal-body">
      <p *ngIf="signatureModalLoading">Cargando firma…</p>
      <img *ngIf="!signatureModalLoading && signatureModalUrl" [src]="signatureModalUrl" alt="Firma del cliente" />
      <p class="report-error" *ngIf="signatureModalError">{{ signatureModalError }}</p>
    </div>
  </div>
</div>
